import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
import { TranslateService } from '@ngx-translate/core';

import { de_DE, en_US, zh_CN } from 'ng-zorro-antd/i18n';

import { languages } from '@app/configurations';
import { UserLanguage } from '../models/user.models';

/**
 * Registers locale data for internationalization
 */
export function registerLocales(): void {
  registerLocaleData(en);
  registerLocaleData(de);
  registerLocaleData(zh);
}

export function getLocaleFactory(ts: TranslateService): typeof de_DE | typeof zh_CN | typeof en_US {
  const lang =
    (typeof URLSearchParams !== 'undefined' && new URLSearchParams(location.search).get('lang')) ||
    ts.currentLang ||
    ts.getBrowserLang();

  if (lang.toUpperCase() === languages.GERMAN) {
    return de_DE;
  } else if (lang.toUpperCase() === languages.CHINESE) {
    return zh_CN;
  } else {
    return en_US;
  }
}

export function getLocaleIdFactory(ts: TranslateService): string {
  return getLocaleFactory(ts).locale;
}

export function getDefaultLanguage(currentLang?: string, storedLang?: string): UserLanguage {
  if (storedLang) storedLang = (<any>storedLang).toUpperCase();
  if (currentLang) currentLang = (<any>currentLang).toUpperCase();

  const defaultLanguage = languages.ENGLISH;
  const browserLanguage = navigator.language?.split('-').shift().toUpperCase() as UserLanguage;
  const browserLanguages = navigator.languages?.map((l) => l.split('-').shift().toUpperCase() as UserLanguage);
  const availableLanguages = Object.values(languages);

  let updateLanguage: UserLanguage;

  if (availableLanguages.includes(storedLang as UserLanguage)) {
    updateLanguage = storedLang as UserLanguage;
  } else if (availableLanguages.includes(browserLanguage)) {
    updateLanguage = browserLanguage;
  } else {
    updateLanguage = browserLanguages.find((l) => availableLanguages.includes(l)) || defaultLanguage;
  }

  if (currentLang !== updateLanguage) {
    return <UserLanguage>updateLanguage.toLowerCase();
  }
}
